import { takeEvery } from 'redux-saga/effects'
import * as action from '../actions'
import firebase from '../middleware/firebase'

function* watchForLoginSucceeded() {
  yield takeEvery(action.LOAD_USER_PROFILE, ({ payload }) => {
    firebase.signIn(payload)
  })
}

function* watchForLogout() {
  yield takeEvery(action.LOGOUT, () => {
    firebase.signOut()
  })
}

export default [watchForLoginSucceeded, watchForLogout]



// WEBPACK FOOTER //
// ./src/sagas/firebase.jsx